<template>
  <div>
    <v-row>
      <v-col :md="12" :sm="12" :xs="12" cols="12">
        <v-card outlined class="app-card">
          <v-card-title class="app-card-title">
            Passe Livre Intermunicipal
            <!-- <v-btn
              text
              small
              @click="dialog = true"
              style="position: absolute; right: 4px;"
              ><v-icon>info</v-icon> Orientações</v-btn
            >-->
          </v-card-title>
          <v-card-text class="app-card-content">
            <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
              <v-row>
                <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0">
                  <v-text-field
                    v-model="form.cpf"
                    placeholder="Digite seu cpf"
                    label="CPF *"
                    v-mask="'###.###.###-##'"
                    :rules="[rules.required, rules.cpf]"
                    filled
                    rounded
                    dense
                  ></v-text-field>
                </v-col>
                <v-col :md="12" :sm="12" :xs="12" cols="12" class="pt-0">
                  <v-text-field
                    v-model="form.nascimento"
                    placeholder="Ex.: 13/03/1955"
                    label="Data de Nascimento *"
                    v-mask="'##/##/####'"
                    :rules="[rules.required, rules.birth]"
                    filled
                    rounded
                    dense
                  ></v-text-field>
                </v-col>
                <v-col :md="9" :sm="9" :xs="12" cols="12" class="pt-0 pb-0">
                  <vue-recaptcha
                    ref="recaptcha"
                    :sitekey="siteKey"
                    :loadRecaptchaScript="true"
                    @verify="verifyRecaptcha"
                    @expired="expiredRecaptcha"
                    class="recaptcha"
                  ></vue-recaptcha>
                  <v-input
                    v-model="form.recaptcha"
                    :rules="[rules.required]"
                    style="margin-top: -23px"
                  ></v-input>
                </v-col>
                <v-col :md="3" :sm="3" :xs="12" cols="12">
                  <v-btn depressed block large color="primary" type="submit">Continuar</v-btn>
                </v-col>
              </v-row>
            </v-form>
            <div class="loading" v-if="isLoading">
              <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="900">
      <v-card outlined class="app-card">
        <v-card-title class="app-card-title" primary-title>Orientações</v-card-title>

        <v-card-text class="app-card-content">
          <Orientacoes />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import VueRecaptcha from 'vue-recaptcha';
import { VUE_APP_RECAPTCHA_KEY } from '@/commons/config';
import BeneficiarioAuthService from '@/services/beneficiario.auth.service';
import BeneficiarioModule from '@/store/modules/beneficiario';
import { validateCpf } from '@/helpers/cpf.validator';
import Orientacoes from './Orientacoes';

import { checkDate } from '@/util/validate';
import moment from 'moment';

import GlobalStore from '@/store/modules/global';

export default {
  components: {
    VueRecaptcha,
    Orientacoes,
  },
  directives: {
    mask,
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      dialog: false,
      form: {
        cpf: null,
        nascimento: null,
        recaptcha: null,
      },
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
        cpf: value => !!validateCpf(value) || 'CPF inválido',
        birth: value => !!checkDate(value) || 'Data de Nascimento inválida',
      },
    };
  },
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        this.isLoading = true;
        const { cpf, nascimento, recaptcha } = this.form;
        BeneficiarioAuthService.login(
          this.removeMask(cpf),
          this.formatDate(nascimento),
          recaptcha
        ).subscribe(
          res => {
            this.isLoading = false;
            this.$refs.form.reset();
            this.$refs.recaptcha.reset();
          },
          error => {
            const { response: data } = error;
            if (data && data.data.message === 'Beneficiário não encontrado.') {
              GlobalStore.setSnackBar({
                show: false,
                message: 'Beneficiário não encontrado. Por favor, realize o cadastro.',
                type: 'warning',
                timeout: 4000,
              });
              this.$router.push({ name: 'passe-livre-cadastro' });
            }
            this.isLoading = false;
            this.expiredRecaptcha();
            throwError(error);
          }
        );
      }
    },
    removeMask(value) {
      return value ? value.replace(/\D+/g, '') : null;
    },
    formatDate(value) {
      const data = moment(value, 'DD/MM/YYYY', true);
      return value ? moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
    },
  },
};
</script>
